/* eslint-disable react/prop-types */ /* eslint-disable import/prefer-default-export */ /* eslint-disable no-unused-vars */ /* eslint-disable no-shadow */ import React, {
  useState,
  useContext,
  useEffect,
} from 'react';
import { useTranslation } from 'react-i18next';
import Grid from '@material-ui/core/Grid';

import Filter from './Filter';
import { ReceivablesTable } from './table/ReceivablesTable';
import FlashContext from '../../components/contexts/FlashContext';
import api from '../../service/axios/api';
import Loading from '../../components/loading/Loading';
import Create from './modals/Create';
import { formatCurrency } from '../../service/utils';

export default function Receivables() {
  const { t } = useTranslation();
  const { notifyError, notifySuccess } = useContext(FlashContext);

  const today = new Date();
  const monthOptions = [
    { value: 'all', label: t('receivables.filter.months.all') },
    { value: '1', label: t('receivables.filter.months.january') },
    { value: '2', label: t('receivables.filter.months.february') },
    { value: '3', label: t('receivables.filter.months.march') },
    { value: '4', label: t('receivables.filter.months.april') },
    { value: '5', label: t('receivables.filter.months.may') },
    { value: '6', label: t('receivables.filter.months.june') },
    { value: '7', label: t('receivables.filter.months.july') },
    { value: '8', label: t('receivables.filter.months.august') },
    { value: '9', label: t('receivables.filter.months.september') },
    { value: '10', label: t('receivables.filter.months.october') },
    { value: '11', label: t('receivables.filter.months.november') },
    { value: '12', label: t('receivables.filter.months.december') },
  ];
  const currentYear = today.getFullYear();
  const yearOptions = Array.from({ length: 5 }, (__, i) => ({
    value: (currentYear - i).toString(),
    label: (currentYear - i).toString(),
  }));

  const [data, setData] = useState([]);
  const [totalAmount, setTotalAmount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [total, setTotal] = useState(0);
  const [itens, setItens] = useState(10);
  const [chipData, setChipData] = useState([]);
  const [month, setMonth] = useState('all');
  const [year, setYear] = useState(currentYear.toString());

  const [loadingCreate, setLoadingCreate] = useState(false);
  const [openCreate, setOpenCreate] = useState(false);
  const [client, setClient] = useState(null);
  const [dueDate, setDueDate] = useState(new Date());
  const [amount, setAmount] = useState('');
  const [costCenter, setCostCenter] = useState('');
  const [description, setDescription] = useState('');

  const handleCleanCreate = () => {
    setClient(null);
    setDueDate(new Date());
    setAmount('');
    setDescription('');
    setCostCenter('');
    setOpenCreate(false);
  };

  const handleCreate = async () => {
    console.log(client, amount, dueDate, description);
    if (client === null) {
      notifyError('Escolha um cliente');
      return;
    }
    const moneyRegex = /^\d+([.,]\d{1,2})?$/;
    if (!amount || amount.trim().length === 0 || !moneyRegex.test(amount)) {
      notifyError('O valor deve ser numérico');
      return;
    }
    if (description.length === 0) {
      notifyError('Insira uma descrição');
      return;
    }
    setLoadingCreate(true);

    try {
      const { data } = await api.receivables.create(
        client,
        costCenter,
        amount,
        dueDate,
        description,
      );
      notifySuccess(data.message);
      handleCleanCreate();
      searchData();
    } catch (error) {
      if (error.problems && error.problems.length > 0) {
        error.problems.forEach(err => {
          notifyError(err.msg);
        });
      } else {
        notifyError(error.message);
      }
    } finally {
      setLoadingCreate(false);
    }
  };

  const searchData = async currentChips => {
    setLoading(true);

    const filtersToUse = currentChips || chipData;
    try {
      const receivables = await api.receivables.getAll(
        filtersToUse,
        itens,
        page + 1,
        month,
        year,
      );
      const amount = await api.receivables.getTotalAmount();
      setTotal(receivables.data.total);
      setData(receivables.data.docs);
      setTotalAmount(amount.data.retorno);
    } catch (error) {
      console.log(error);
      notifyError(error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    searchData();
  }, [page, itens]);

  return (
    <>
      <Loading open={loading} msg={t('receivables.loading')} />
      <Grid>
        <Grid
          item
          xs={12}
          sm={12}
          style={{ display: 'flex', justifyContent: 'start' }}
        >
          <h3>{t('receivables.title')}</h3>
        </Grid>

        <Filter
          setChipData={setChipData}
          chipData={chipData}
          find={searchData}
          setPage={setPage}
          setOpenDialog={setOpenCreate}
          monthOptions={monthOptions}
          month={month}
          setMonth={setMonth}
          yearOptions={yearOptions}
          year={year}
          setYear={setYear}
        />
        <div
          style={{
            marginBottom: '15px',
            display: 'flex',
            justifyContent: 'end',
          }}
        >
          <h4>{`${t('receivables.totalAmount')} ${formatCurrency(
            totalAmount || 0,
          )}`}</h4>
        </div>
        <ReceivablesTable
          docs={data}
          page={page}
          setPage={setPage}
          itens={itens}
          setItens={setItens}
          total={total}
          searchData={searchData}
        />
      </Grid>
      <Create
        openCreate={openCreate}
        setOpenCreate={setOpenCreate}
        loadingCreate={loadingCreate}
        handleCreate={handleCreate}
        handleClean={handleCleanCreate}
        client={client}
        setClient={setClient}
        amount={amount}
        setAmount={setAmount}
        dueDate={dueDate}
        setDueDate={setDueDate}
        costCenter={costCenter}
        setCostCenter={setCostCenter}
        description={description}
        setDescription={setDescription}
      />
    </>
  );
}
